var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m478.244 135.737a10.784 10.784 0 0 1 7.827 10.334v287.4h-151.678v-314.46a446.229 446.229 0 0 1 143.851 16.726zm-363.733 8.629h-56.193v25.884h56.193zm0-63.8a519.148 519.148 0 0 0 -56.193 9.934v7.985h56.193zm97.017-12.265v-8.501a7.451 7.451 0 0 0 -6.039-7.366 168.8 168.8 0 0 0 -61.92 0 7.452 7.452 0 0 0 -6.041 7.366v8.509a511.4 511.4 0 0 1 74-.003zm181.455 41.737v-1.938a7.453 7.453 0 0 0 -6.04-7.366 168.69 168.69 0 0 0 -54.733-1.173 22.85 22.85 0 0 1 2.171 9.439 442.845 442.845 0 0 1 58.602 1.043zm-278.472-1.561h-56.193v25.884h56.193zm377.4 334.993h-471.825a9.479 9.479 0 1 0 0 18.957h471.828a9.479 9.479 0 1 0 0-18.957zm-377.4-191.459h-56.193v25.889h56.193zm0 35.884h-56.193v25.884h56.193zm0 35.884h-56.193v25.884h56.193zm209.882-214.512a13.1 13.1 0 0 0 -9.506-12.551c-63.128-17.852-126.859-23.588-190.376-17.239v297.574a5 5 0 0 1 -10 0v-17.383h-56.193v17.383a5 5 0 0 1 -10 0v-284.113c-4.719 1.2-9.435 2.445-14.148 3.778a13.1 13.1 0 0 0 -9.506 12.551v324.208h299.729zm-209.882 70.983h-56.193v25.884h56.193zm0 35.884h-56.193v25.882h56.193z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTank);
export default __webpack_public_path__ + "static/media/tank.3f6edccc11ab6a401bd59ee2754cfdd7.svg";
export { ForwardRef as ReactComponent };